import { createContext, useContext } from 'react';

export const PreviousLocationContext = createContext();

export const usePreviousLocationContext = () =>
  useContext(PreviousLocationContext);
